module.exports = __webpack_public_path__ + "img/opening-time.3c360686.svg";